/** 菜单去重工具函数 用于解决用户拥有多个角色时菜单重复显示的问题 */

import type { App } from '@/typings/global';

/**
 * 对菜单数组进行去重处理
 *
 * @param menus 菜单数组
 * @returns 去重后的菜单数组
 */
export function deduplicateMenus(menus: App.Global.Menu[]): App.Global.Menu[] {
  const menuKeySet = new Set<string>();
  const result: App.Global.Menu[] = [];

  for (const menu of menus) {
    if (!menuKeySet.has(menu.key)) {
      menuKeySet.add(menu.key);

      // 递归处理子菜单
      if (menu.children?.length) {
        menu.children = deduplicateMenus(menu.children);
      }

      result.push(menu);
    }
  }

  return result;
}

/**
 * 深度去重菜单，确保所有层级的菜单都不会重复
 *
 * @param menus 菜单数组
 * @returns 深度去重后的菜单数组
 */
export function deepDeduplicateMenus(menus: App.Global.Menu[]): App.Global.Menu[] {
  const allMenuKeys = new Set<string>();
  const result: App.Global.Menu[] = [];

  function collectMenuKeys(menuList: App.Global.Menu[]): void {
    for (const menu of menuList) {
      allMenuKeys.add(menu.key);
      if (menu.children?.length) {
        collectMenuKeys(menu.children);
      }
    }
  }

  function filterMenus(menuList: App.Global.Menu[]): App.Global.Menu[] {
    const filtered: App.Global.Menu[] = [];

    for (const menu of menuList) {
      if (allMenuKeys.has(menu.key)) {
        const newMenu = { ...menu };
        if (newMenu.children?.length) {
          newMenu.children = filterMenus(newMenu.children);
        }
        filtered.push(newMenu);
        allMenuKeys.delete(menu.key); // 移除已使用的key，避免重复
      }
    }

    return filtered;
  }

  // 首先收集所有菜单key
  collectMenuKeys(menus);

  // 然后过滤菜单
  return filterMenus(menus);
}
